import React from "react";

function cyrcleIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2861_4181)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.0274 18.5473C5.41232 18.5473 1.67126 14.8062 1.67126 10.1911C1.67126 5.57601 5.41232 1.83496 10.0274 1.83496C14.6425 1.83496 18.3836 5.57601 18.3836 10.1911C18.3836 14.8062 14.6425 18.5473 10.0274 18.5473ZM10.0274 17.5445C11.9777 17.5445 13.848 16.7698 15.2271 15.3908C16.6061 14.0117 17.3808 12.1414 17.3808 10.1911C17.3808 8.24087 16.6061 6.3705 15.2271 4.99147C13.848 3.61243 11.9777 2.8377 10.0274 2.8377C8.07718 2.8377 6.2068 3.61243 4.82777 4.99147C3.44874 6.3705 2.674 8.24087 2.674 10.1911C2.674 12.1414 3.44874 14.0117 4.82777 15.3908C6.2068 16.7698 8.07718 17.5445 10.0274 17.5445Z"
          fill="#424242"
        />
      </g>
      <defs>
        <clipPath id="clip0_2861_4181">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default cyrcleIcon;
